import { Key } from 'react'
import { Item, Section } from '@react-stately/collections'

import Styles from './WorkspacesMenu.module.scss'

import { groupWorkspacesByType } from 'utils/workspaceUtils'

import { AddSquare02, ArrowLeft, Logout1 } from 'blaze-ui/icons'

import { WorkspaceMenuItemContent } from './WorkspaceMenuItemContent'
import { Menu } from 'components/Menu/Menu'
import { Workspace } from 'types'
import { Heading } from 'blaze-ui/Heading/Heading'
import { IconButton } from 'blaze-ui/IconButton/IconButton'

export const WorkspacesMenu = ({
  onBack,
  onAction,
  onClose,
  workspaces,
  workspaceId,
  hideHeading,
}: {
  onBack: () => void
  onAction: (key: Key) => void
  onClose: () => void
  workspaces: Workspace[]
  workspaceId: number
  hideHeading?: boolean
}) => {
  const { member: memberWorkspaces = [], guest: guestWorkspaces = [] } = groupWorkspacesByType(workspaces)

  return (
    <div className={Styles.root}>
      {!hideHeading && (
        <div className={Styles.header}>
          <IconButton icon={ArrowLeft} size="xs" variant="tertiary" onPress={onBack} />
          <Heading level={5}>Switch Workspace</Heading>
        </div>
      )}

      <div className={Styles.divider} />
      <div className={Styles.menuScrollWrapper}>
        <Menu
          aria-label="Workspaces"
          itemClassName={Styles.menuItem}
          onAction={onAction}
          selectionMode="single"
          selectedKeys={new Set([`workspace-${workspaceId}`])}
          showCheckmark={false}
        >
          <Section>
            {[
              ...memberWorkspaces.concat(guestWorkspaces).map((w) => (
                <Item key={`workspace-${w.id}`} textValue={w.name}>
                  <WorkspaceMenuItemContent workspace={w} isSelected={w.id === workspaceId} onAction={onClose} />
                </Item>
              )),
            ]}
          </Section>
          <Section>
            {[
              <Item key="newWorkspace" textValue="Create new workspace">
                <AddSquare02 />
                Create workspace
              </Item>,
              <Item key="signout" textValue="Sign out">
                <Logout1 /> Sign out
              </Item>,
            ]}
          </Section>
        </Menu>
      </div>
    </div>
  )
}
